import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs';
import { DenunciasService } from 'src/app/services/denuncias.service';
import { ToastrService } from 'ngx-toastr';
import { ReCaptchaV3Service } from 'ng-recaptcha';

import * as moment from 'moment';

@Component({
  selector: 'app-consulta',
  templateUrl: './consulta.component.html',
  styleUrls: ['./consulta.component.css']
})
export class ConsultaComponent implements OnInit {
  buscarForm: FormGroup;

  denuncia: any = null;
  busqueda: boolean = false;

  dataSource = new MatTableDataSource<any[]>([]);
  displayedColumns: string[] = ['id', 'fechaIngreso', 'estado', 'fechaResolucion', 'opciones'];

  recaptchaSubscription: any;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private recaptchaV3Service: ReCaptchaV3Service,
    private denunciasService: DenunciasService,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService
  ) {
    this.buscarForm = this.fb.group({
      codigo: this.fb.control(null, Validators.required),
      correo: this.fb.control(null),
      token: this.fb.control(null),
      fono: this.fb.control(null),
    });
  }

  ngOnInit(): void { }

  ngOnDestroy() {
    if (this.recaptchaSubscription) {
      this.recaptchaSubscription.unsubscribe();
    }
    const element = document.getElementsByClassName('grecaptcha-badge')[0] as HTMLElement;
    if (element) {
      element.style.visibility = 'hidden';
    }
  }

  ngAfterViewInit() {
    const element = document.getElementsByClassName('grecaptcha-badge')[0] as HTMLElement;
    if (element) {
      element.style.visibility = 'visible';
    }
  }


  buscarDenuncia() {
    this.spinner.show();

    if (!this.buscarForm.valid) {
      this.toastrService.warning("Debes completar los campos del formulario para la busqueda");
      this.spinner.hide();
      return;
    }

    this.recaptchaSubscription = this.recaptchaV3Service.execute('registerCustomer').subscribe({
      next: async (resultado: any) => {
        if (resultado) {
          this.denunciasService.buscarDenuncia(this.buscarForm.value)
          .pipe(finalize(() => this.spinner.hide()))
          .subscribe((result) => {
         
            if(result.anonimo){
              if (this.buscarForm.value.codigo != null && this.buscarForm.value.token != null){
                this.busqueda = true;
                this.denuncia = result;
                this.dataSource = new MatTableDataSource([result]);
              }else{
                this.busqueda = false;
                this.toastrService.warning("La Denuncia consultada es anonima debes incluir tu token en la consulta intenta nuevamnete");
              }
              
            }else{
              if (this.buscarForm.value.codigo != null){
                if(this.buscarForm.value.correo != null || this.buscarForm.value.fono != null){
                  this.busqueda = true;
                  this.denuncia = result;
                  this.dataSource = new MatTableDataSource([result]);
                }else{
                  this.busqueda = false;
                  this.toastrService.warning("La Denuncia consultada no es anonima debes incluir tu correo en la consulta intenta nuevamnete");
                }
              }else{
                this.busqueda = false;
                this.toastrService.warning("La Denuncia consultada no es anonima debes incluir tu correo en la consulta intenta nuevamnete");
              }
            }
            
          
          });
        }
      },
      error: (err) => {
        this.spinner.hide();
        console.log(err);
        this.toastrService.error("Ha ocurrido un error en el proceso");
      }
    });

  
  }

  formatoFecha(fecha: string) {
    if (fecha) {
      return moment(fecha).format('DD/MM/YYYY')
    }
    return '';
  }

  verDetalles() {

  }

  cancelar() {
    this.router.navigate(['/home']);
  }

}
